import React from 'react';
import { Col, Button, DatePicker, TimePicker, Select, Input, Row, Divider } from 'antd';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import FilePreviewUploader from '../FilePreviewUploader';

function Itinerary({ Form }) {
	return (
		<Form.List name='defaultItinerary'>
			{(fields, { add, remove }) => (
				<Row gutter={[16, 0]}>
					{fields.map(({ key, name }) => (
						<React.Fragment key={key}>
							<Col sm={24} md={6}>
								<Form.Item label='Itinerary Name' name={[name, 'itineraryName']}>
									<Input placeholder='For e.g. Day 1 Pune -> Nashik' maxLength={250} />
								</Form.Item>
							</Col>
							{/* <Col sm={24} md={4}>
								<Form.Item label='Starting Point Location' name={[name, 'itineraryLocation']}>
									<Input placeholder='Kothrud' maxLength={250} />
								</Form.Item>
							</Col>
							<Col sm={24} md={4}>
								<Form.Item label='Starting City' name={[name, 'itineraryCity']}>
									<Input placeholder='Pune' maxLength={250} />
								</Form.Item>
							</Col>
							<Col sm={24} md={5}>
								<Form.Item label='Starting Point Plus Code' name={[name, 'itineraryPlusCode']}>
									<Input placeholder='GQ4V+FX' maxLength={250} />
								</Form.Item>
							</Col> */}
							<Col sm={24} md={6}>
								<Form.Item label='Transport Mode' name={[name, 'itineraryTransportMode']}>
									<Select
										allowClear
										showArrow
										mode='multiple'
										style={{ width: '100%' }}
										placeholder='Bike, Car, Bus, Railway, Flight, Ferry etc.'
										options={[
											{ label: 'Bike', value: 'Bike' },
											{ label: 'Car', value: 'Car' },
											{ label: 'Bus', value: 'Bus' },
											{ label: 'Railway', value: 'Railway' },
											{ label: 'Flight', value: 'Flight' },
											{ label: 'Ferry', value: 'Ferry' },
										]}
									/>
								</Form.Item>
							</Col>
							<Col sm={24} md={6}>
								<Form.Item label='Meals Included' name={[name, 'itineraryMealsIncluded']}>
									<Select
										allowClear
										showArrow
										mode='multiple'
										style={{ width: '100%' }}
										placeholder='Tea, Breakfast, Lunch, Evening Snacks, Dinner'
										options={[
											{ label: 'Tea', value: 'Tea' },
											{ label: 'Breakfast', value: 'Breakfast' },
											{ label: 'Lunch', value: 'Lunch' },
											{ label: 'Evening Snacks', value: 'Evening Snacks' },
											{ label: 'Dinner', value: 'Dinner' },
										]}
									/>
								</Form.Item>
							</Col>
							<Col sm={24} md={6}>
								{fields.length > 1 ? (
									<Form.Item label='&nbsp;'>
										<Button icon={<CloseOutlined />} shape='circle' onClick={() => remove(name)} />
									</Form.Item>
								) : null}
							</Col>
							<Col sm={24} md={12}>
								<Form.Item label='Description' name={[name, 'itineraryDescription']}>
									<Input.TextArea maxLength={5000} style={{ width: '100%' }} autoSize={{ minRows: 4 }} placeholder='Description about itinerary' />
								</Form.Item>
							</Col>
							{/* <Col sm={24} md={12}>
								<Form.Item label='Itinerary attractions' name={[name, 'itineraryAttractions']}>
									<FilePreviewUploader Form={Form} maxItems={10} />
								</Form.Item>
							</Col> */}
							<Divider style={{ margin: 0, marginBottom: 16 }} />
						</React.Fragment>
					))}
					<Col span={6}>
						<Form.Item>
							<Button
								icon={<PlusOutlined />}
								type='primary'
								onClick={() => {
									add();
								}}
								style={{ width: '100%' }}
							>
								Add Itinerary
							</Button>
						</Form.Item>
					</Col>
				</Row>
			)}
		</Form.List>
	);
}

export default Itinerary;
